import(/* webpackMode: "eager" */ "/app/webapp/app/pwa/error.tsx");
